module.exports = __webpack_public_path__ + "188675f3043660a109914b6ad6a62d75.MP3";